import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import MyCourses from "./pages/MyCourses";
import Catalog from "./pages/Catalog";
import CourseDetail from "./pages/CourseDetail";
import CoursePlayer from "./pages/CoursePlayer";
import Quiz from "./pages/Quiz";
import ProgressPage from "./pages/Progress";
import Settings from "./pages/Settings";
import Certificates from "./pages/Certificates";
import CertificateViewer from "./pages/CertificateViewer";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminCourses from "./pages/admin/AdminCourses";
import AdminCertificates from "./pages/admin/AdminCertificates";
import AdminEnrollments from "./pages/admin/AdminEnrollments";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminDiscounts from "./pages/admin/AdminDiscounts";
import AdminBroadcasts from "./pages/admin/AdminBroadcasts";
import AdminRefunds from "./pages/admin/AdminRefunds";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Wishlist from "./pages/Wishlist";
import Cart from "./pages/Cart";
import Community from "./pages/Community";

function AppRouter() {
    const location = useLocation();
    // CRITICAL race-condition guard: handle session_id callback synchronously
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/my-courses" element={<MyCourses />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/catalog/:courseId" element={<CourseDetail />} />
            <Route path="/learn/:courseId" element={<CoursePlayer />} />
            <Route path="/learn/:courseId/quiz/:quizId" element={<Quiz />} />
            <Route path="/community/:courseId" element={<Community />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/progress" element={<ProgressPage />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/certificates" element={<Certificates />} />
            <Route path="/certificates/:certId" element={<CertificateViewer />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/customers" element={<AdminCustomers />} />
            <Route path="/admin/courses" element={<AdminCourses />} />
            <Route path="/admin/enrollments" element={<AdminEnrollments />} />
            <Route path="/admin/certificates" element={<AdminCertificates />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/admin/discounts" element={<AdminDiscounts />} />
            <Route path="/admin/broadcasts" element={<AdminBroadcasts />} />
            <Route path="/admin/refunds" element={<AdminRefunds />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Toaster
                        theme="dark"
                        position="top-right"
                        toastOptions={{
                            style: { background: "#1A1C20", border: "1px solid rgba(255,255,255,0.08)", color: "#ffffff" },
                        }}
                    />
                    <AppRouter />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
